"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./models"));
__export(require("./comparisonEngine"));
__export(require("./dateWindowEngine"));
__export(require("./domain"));
var engine_1 = require("./engine");
exports.generatePillValues = engine_1.generatePillValues;
exports.getInitialValue = engine_1.getInitialValue;
exports.calculateComparison = engine_1.calculateComparison;
exports.getDateRange = engine_1.getDateRange;
exports.parseDateTrunc = engine_1.parseDateTrunc;
var hitMapCalculator_1 = require("./hitMapCalculator");
exports.calculateHitMaps = hitMapCalculator_1.calculateHitMaps;
var numberFormatter_1 = require("./formatting/numberFormatter");
exports.formatAbsoluteValue = numberFormatter_1.formatAbsoluteValue;
exports.formatComparisonWidgetText = numberFormatter_1.formatComparisonWidgetText;
exports.formatPillValue = numberFormatter_1.formatPillValue;
exports.formatValueAsMetricNumber = numberFormatter_1.formatValueAsMetricNumber;
exports.formatValueAsRelativeNumber = numberFormatter_1.formatValueAsRelativeNumber;
exports.formatValueAsRelativePercentage = numberFormatter_1.formatValueAsRelativePercentage;
var localization_1 = require("./localization");
exports.setEngineLocale = localization_1.setEngineLocale;
var dateFormatter_1 = require("./formatting/dateFormatter");
exports.dateFormatterFactory = dateFormatter_1.dateFormatterFactory;
var parseDataPoints_1 = require("./parseDataPoints");
exports.parseDataPoints = parseDataPoints_1.parseDataPoints;
exports.validDateOrUndefined = parseDataPoints_1.validDateOrUndefined;
//# sourceMappingURL=MetricsEngine.js.map